import { useLang } from "@/i18n/LanguageContext";

const APPLE_LOCALES = { de: "de-de", en: "en-us", es: "es-es", it: "it-it", fr: "fr-fr" };
const APP_STORE_URL = "https://apps.apple.com/app/id6802234267";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.emergent.beautyinsight.s29va4";

const openDeepLink = (deepLink, storeUrl) => (e) => {
  e.preventDefault();
  const timer = setTimeout(() => {
    if (!document.hidden) window.location.href = storeUrl;
  }, 1500);
  const onHide = () => {
    if (document.hidden) {
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", onHide);
    }
  };
  document.addEventListener("visibilitychange", onHide);
  window.location.href = deepLink;
};

export const StoreBadges = ({ height = 48, className = "", deepLink }) => {
  const { lang } = useLang();
  const linkProps = (storeUrl) =>
    deepLink
      ? { href: storeUrl, onClick: openDeepLink(deepLink, storeUrl) }
      : { href: storeUrl, target: "_blank", rel: "noopener noreferrer" };
  return (
    <div className={`flex items-center gap-3 flex-wrap ${className}`}>
      <a {...linkProps(APP_STORE_URL)} data-testid="appstore-badge" aria-label="App Store" className="inline-block transition-transform duration-300 hover:-translate-y-0.5">
        <img
          src={`https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/${APPLE_LOCALES[lang]}`}
          alt="Download on the App Store"
          style={{ height }}
        />
      </a>
      <a {...linkProps(PLAY_STORE_URL)} data-testid="playstore-badge" aria-label="Google Play" className="inline-block transition-transform duration-300 hover:-translate-y-0.5">
        <img
          src={`https://play.google.com/intl/en_us/badges/static/images/badges/${lang}_badge_web_generic.png`}
          alt="Get it on Google Play"
          style={{ height: height * 1.48, margin: `-${height * 0.24}px 0` }}
        />
      </a>
    </div>
  );
};
